import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';
import { RetornoMercaderiaComponent } from './retorno-mercaderia/retorno-mercaderia.component';
import { RetornoMecaderiaComponentModalAddEditComponent } from './retorno-mercaderia/modal-add-edit/modal-add-edit.component';
import { DevolucionMercaderiaComponent } from './devolucion-mecaderia/devolucion-mercaderia.component';
import { DevolucionMercaderiaModalSeleccionarRecorridoComponent } from './devolucion-mecaderia/modal-seleccionar-recorrido/modal-seleccionar-recorrido.component';
import { DevolucionMercaderiaModalDevolverDocumentoComponent } from './devolucion-mecaderia/modal-devolver-documento/modal-devolver-documento.component';
import { DevolucionMercaderiaModalDevolverProductoComponent } from './devolucion-mecaderia/modal-devolver-producto/modal-devolver-producto.component';
import { LiquidacionRecorridoComponent } from './liquidacion-recorrido/liquidacion-recorrido.component';
import { LiquidacionRecorridoTabsFormaPagoComponent } from './liquidacion-recorrido/tabs-forma-pago/tabs-forma-pago.component';
import { LiquidacionControlEfectivoComponent } from './control-efectivo/modal-liquidacion-control-efectivo.component';
import { ModalSeleccionarRecorridoLiquidacionComponent } from './liquidacion-recorrido/modal-seleccionar-recorrido-liquidacion/modal-seleccionar-recorrido-liquidacion.component';
import { ConsultaRecorridoComponent } from './consulta-recorrido/consulta-recorrido.component';
import { ConsultaRecorridoDetalleComponent } from './consulta-recorrido/modal-detalle/modal-consulta-recorrido-detalle.component';

// elementos usados en scroll infinito
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { SearchRecorridoTableComponent } from './liquidacion-recorrido/search-recorrido-table/search-recorrido-table/search-recorrido-table.component';
@NgModule({
  declarations: [
    RetornoMercaderiaComponent,
    RetornoMecaderiaComponentModalAddEditComponent,
    DevolucionMercaderiaComponent,
    DevolucionMercaderiaModalSeleccionarRecorridoComponent,
    DevolucionMercaderiaModalDevolverDocumentoComponent,
    DevolucionMercaderiaModalDevolverProductoComponent,
    LiquidacionRecorridoComponent,
    LiquidacionRecorridoTabsFormaPagoComponent,
    LiquidacionControlEfectivoComponent,
    ModalSeleccionarRecorridoLiquidacionComponent,
    ConsultaRecorridoComponent,
    ConsultaRecorridoDetalleComponent,
    SearchRecorridoTableComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class LiquidacionRecorridosModule { }
